export enum PriKeys {
    SetFollowup = -52,
    MailTaskUsers = -45,
    SendLink = -31,
    App = 13,
    Clnln = 38,
    AttachActivateApp = 92,
    AttachImport = 94,
    Navigate = 103,
    SendExcel = 104,
    SendWord = 120,
    MailInterface = 124,
    NoOfRows = 134
}
